import { render, staticRenderFns } from "./maintenanceList.vue?vue&type=template&id=b2986708"
import script from "./maintenanceList.vue?vue&type=script&lang=js"
export * from "./maintenanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports